import { Card, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { PageTitle } from '../../components/PageTitle';
import { useTranslation } from 'react-i18next';
import { JournalsIntelligenceContent } from './components/JournalsIntelligenceContent';
import Loader from '../../components/Loader';

export const JournalsIntelligence = () => {
  const { t } = useTranslation();

  // TODO: Replace with actual loading state and data fetching logic
  const isLoading = false;

  return (
    <>
      <PageTitle title={t('journalsIntelligence.title') as string} />
      <Box>
        <Card variant="default">
          <Stack spacing={24}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                gap: 10,
              }}
            >
              <Box>
                <Typography variant="h4" gutterBottom>
                  {t('journalsIntelligence.title')}
                </Typography>
                <Typography variant="body1">
                  {t('journalsIntelligence.description')}
                </Typography>
              </Box>
            </Box>
          </Stack>
        </Card>
        {isLoading ? (
          <Box my={32}>
            <Loader />
          </Box>
        ) : (
          <>
            <Card variant="default" className="mt-6">
              <Box>
                <JournalsIntelligenceContent />
              </Box>
            </Card>
          </>
        )}
      </Box>
    </>
  );
};
